import { rawTimeZones } from '@vvo/tzdb';
export const getTimezoneAbbreviation = () => {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    const rawTimeZone = rawTimeZones.find(({ name }) => name === timeZone);
    return rawTimeZone === null || rawTimeZone === void 0 ? void 0 : rawTimeZone.abbreviation;
};
